export const OPEN_CONSENT_MODAL = '@app/consentModal/openConsentModalAction';
export const CLOSE_CONSENT_MODAL = '@app/consentModal/closeConsentModalAction';
export const FETCHED_CONSENT_DETAIL = '@app/consentModal/fetchedConsentDetailAction';
export const FETCHING_CONSENT_DETAIL = '@app/consentModal/fetchingConsentDetailAction';

export const openConsentModalAction = (title, detailUrl) => ({
	type: OPEN_CONSENT_MODAL,
	title,
	detailUrl
});

export const closeConsentModalAction = () => ({
	type: CLOSE_CONSENT_MODAL
});

/**
 * @param {string} detailUrl
 * @param {string} html
 *
 * @return {{type: string, detailUrl: string, html: string}}
 */
export const fetchedConsentDetailAction = (detailUrl, html) => ({
	type: FETCHED_CONSENT_DETAIL,
	detailUrl,
	html
});

export const fetchingConsentDetailAction = () => ({
	type: FETCHING_CONSENT_DETAIL
});



// WEBPACK FOOTER //
// ./actions/ConsentModalActions.js